import { styled } from '@volkswagen-onehub/components-core';
import React from 'react';

const ServiceIconWrapper: any = styled.div`
  align-items: center;
  background-color: #0a1f3a;
  border-radius: 50%;
  color: white;
  display: flex;
  height: 35px;
  justify-content: center;
  padding: 6px;
  width: 35px;

  svg {
    height: 20px;
    width: 20px;
  }
`;

export const CustomServiceSvg = () => {
  return (
    <ServiceIconWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 12 13"
        fill="none"
      >
        <path
          d="M9.9766 10.0135C9.9766 9.73698 9.7526 9.51248 9.4756 9.51248C9.1991 9.51248 8.9746 9.73698 8.9746 10.0135C8.9746 10.29 9.1991 10.5145 9.4756 10.5145C9.7526 10.5145 9.9766 10.29 9.9766 10.0135Z"
          fill="#001E50"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.5175 6.20393L4.4475 5.11893L3.5175 4.03393H1C1.0635 3.79993 1.148 3.57843 1.251 3.36893C1.8485 2.15043 3.0785 1.36893 4.6065 1.36893C6.7795 1.36893 8.3565 2.94593 8.3565 5.11893C8.3565 5.49243 8.3065 5.84643 8.219 6.17993L10.806 8.76743C11.4905 9.45193 11.4905 10.5614 10.806 11.2459L10.708 11.3434C10.3665 11.6859 9.9175 11.8569 9.469 11.8569C9.0205 11.8569 8.572 11.6859 8.2295 11.3434L5.627 8.74043C5.305 8.82193 4.965 8.86893 4.6065 8.86893C3.0785 8.86893 1.8485 8.08693 1.251 6.86893C1.148 6.65943 1.0635 6.43743 1 6.20393H3.5175ZM5.07047 8.18432C4.91947 8.20432 4.76547 8.21782 4.60647 8.21782C3.47547 8.21782 2.54047 7.70032 2.00297 6.86882H3.82347L5.04447 5.44432C5.19347 5.26982 5.19847 5.02182 5.07047 4.83682C5.06594 4.83048 5.06244 4.82373 5.05894 4.81699C5.05471 4.80884 5.05049 4.8007 5.04447 4.79332L3.82347 3.36882H2.00297C2.54047 2.53732 3.47547 2.01932 4.60647 2.01932C6.40247 2.01932 7.70597 3.32282 7.70597 5.11882C7.70597 5.29332 7.68997 5.46232 7.66597 5.62732C7.62797 5.88932 7.56347 6.13932 7.46947 6.37132C7.16397 7.12382 6.58047 7.69932 5.82247 7.99532C5.58747 8.08682 5.33547 8.14932 5.07047 8.18432ZM9.46902 11.192C9.17902 11.192 8.90552 11.079 8.70052 10.8735L6.31852 8.49201C7.04102 8.14801 7.61302 7.58351 7.96402 6.86551L10.336 9.23751C10.541 9.44301 10.6545 9.71601 10.6545 10.0065C10.6545 10.297 10.541 10.5705 10.336 10.7755L10.2385 10.8735C10.033 11.079 9.76002 11.192 9.46902 11.192Z"
          fill="white"
        />
        <path
          d="M5.07047 8.18432C4.91947 8.20432 4.76547 8.21782 4.60647 8.21782C3.47547 8.21782 2.54047 7.70032 2.00297 6.86882H3.82347L5.04447 5.44432C5.19347 5.26982 5.19847 5.02182 5.07047 4.83682C5.06594 4.83048 5.06244 4.82373 5.05894 4.81699C5.05471 4.80884 5.05049 4.8007 5.04447 4.79332L3.82347 3.36882H2.00297C2.54047 2.53732 3.47547 2.01932 4.60647 2.01932C6.40247 2.01932 7.70597 3.32282 7.70597 5.11882C7.70597 5.29332 7.68997 5.46232 7.66597 5.62732C7.62797 5.88932 7.56347 6.13932 7.46947 6.37132C7.16397 7.12382 6.58047 7.69932 5.82247 7.99532C5.58747 8.08682 5.33547 8.14932 5.07047 8.18432Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.46902 11.192C9.17902 11.192 8.90552 11.079 8.70052 10.8735L6.31852 8.49201C7.04102 8.14801 7.61302 7.58351 7.96402 6.86551L10.336 9.23751C10.541 9.44301 10.6545 9.71601 10.6545 10.0065C10.6545 10.297 10.541 10.5705 10.336 10.7755L10.2385 10.8735C10.033 11.079 9.76002 11.192 9.46902 11.192ZM9.4756 9.51248C9.7526 9.51248 9.9766 9.73698 9.9766 10.0135C9.9766 10.29 9.7526 10.5145 9.4756 10.5145C9.1991 10.5145 8.9746 10.29 8.9746 10.0135C8.9746 9.73698 9.1991 9.51248 9.4756 9.51248Z"
          fill="white"
        />
      </svg>
    </ServiceIconWrapper>
  );
};
